export default "__VITE_ASSET__C9RLW9x0__"